var _title, _desc, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconCreditCard = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "145px",
    height: "119px",
    viewBox: "0 0 145 119",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 17")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.2688 0.0004 8.2668 0.0004 8.2668 8 0.2688 8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activation---Payment-Successful",
    transform: "translate(-117.000000, -199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(117.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(34.000000, 51.017800)",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.2062,
    y1: 1.8138,
    x2: 103.1322,
    y2: 1.8138,
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.2062,
    y1: 17.9818,
    x2: 103.1322,
    y2: 17.9818,
    id: "Stroke-3"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 44.009,
    y1: 80.193,
    x2: 78.317,
    y2: 80.193,
    id: "Stroke-6",
    stroke: "#0000FF",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 0.017800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.7278,101.7914 C124.7658,101.7914 127.2278,99.3294 127.2278,96.2914 C127.2278,93.2534 124.7658,90.7914 121.7278,90.7914 C118.6898,90.7914 116.2278,93.2534 116.2278,96.2914 C116.2278,99.3294 118.6898,101.7914 121.7278,101.7914",
    id: "Fill-7",
    fill: "#FF00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6242,115.0004 L39.1062,115.0004 C34.3702,115.0004 30.5302,111.1024 30.5302,106.2944 L30.5302,44.1084 C30.5302,39.2984 34.3702,35.4024 39.1062,35.4024 L132.2302,35.4024 C136.9662,35.4024 140.8082,39.2984 140.8082,44.1084 L140.8082,106.2944 C140.8082,111.1024 136.9662,115.0004 132.2302,115.0004 L83.4622,115.0004",
    id: "Stroke-9",
    stroke: "#0000FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(79.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2668,4.0004 C8.2668,6.2084 6.4768,8.0004 4.2688,8.0004 C2.0588,8.0004 0.2688,6.2084 0.2688,4.0004 C0.2688,1.7924 2.0588,0.0004 4.2688,0.0004 C6.4768,0.0004 8.2668,1.7924 8.2668,4.0004",
    id: "Fill-11",
    fill: "#FF00FF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.175,94.8304 L22.541,94.9784 C21.805,95.1444 21.051,95.0244 20.409,94.6264 C19.771,94.2284 19.323,93.6064 19.149,92.8584 L11.875,60.9764 L23.175,58.3364 L23.175,53.2024 L10.761,56.1024 L8.345,45.5124 L23.175,42.0484 L23.175,36.9144 L7.231,40.6364 L5.071,31.1644 C4.727,29.6564 5.673,28.1424 7.179,27.7904 L100.215,6.0584 C101.733,5.7064 103.249,6.6504 103.605,8.1784 L105.759,17.6224 L60.633,28.1644 L82.613,28.1644 L106.873,22.4964 L108.165,28.1644 L113.293,28.1644 L108.469,7.0264 C107.995,4.9924 106.757,3.2644 104.983,2.1624 C103.209,1.0604 101.117,0.7144 99.077,1.1904 L6.043,22.9224 C1.867,23.8984 -0.757,28.0944 0.197,32.2784 L14.285,94.0104 C15.125,97.6144 18.347,100.0524 21.897,100.0524 C22.319,100.0524 22.747,99.9764 23.175,99.9044 L23.175,94.8304 Z",
    id: "Fill-14",
    fill: "#0000FF"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCreditCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-credit-card.55d875e9.svg";
export { ForwardRef as ReactComponent };